import DialogTitle from '@material-ui/core/DialogTitle';

/** @deprecated Exporting the DialogTitle component from the material-ui library. */
export default DialogTitle;
